import { combineReducers } from 'core/redux'

import data from './data'

export default combineReducers({
  data,
})
